import { render } from "./modal-team-details.vue?vue&type=template&id=a5eeeb72"
import script from "./modal-team-details.vue?vue&type=script&lang=js"
export * from "./modal-team-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__